"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WordCardWrapper = function WordCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "expandedId", _descriptor, _this);
      _initializerDefineProperty(_this, "selectedVideoClip", _descriptor2, _this);
      _initializerDefineProperty(_this, "supplementVideoClip", _descriptor3, _this);
      _initializerDefineProperty(_this, "showSourceInput", _descriptor4, _this);
      _initializerDefineProperty(_this, "showSentenceInput", _descriptor5, _this);
      _initializerDefineProperty(_this, "showNoReviewExplanation", _descriptor6, _this);
      _state.DeckUI.createEvent('deck - click on word', {
        deck_id: _state.DeckUI.deck.id,
        target_text: _this.props.word.targetText
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "primaryTranslationText",
      get: function get() {
        var _this$props$word, _this$props$word2, _this$props$word3;
        if (this.props.sentence && !((_this$props$word = this.props.word) !== null && _this$props$word !== void 0 && _this$props$word.isNoun)) {
          return this.props.sentence.targetTextWithPrefix(this.props.word);
        } else if ((_this$props$word2 = this.props.word) !== null && _this$props$word2 !== void 0 && _this$props$word2.isNoun) {
          var _this$props$word$root, _word$pluralNoun;
          var word = this.props.word.rootWord || this.props.word;
          var singular = ((_this$props$word$root = this.props.word.rootWord) === null || _this$props$word$root === void 0 ? void 0 : _this$props$word$root.targetTextWithDefiniteArticle) || '';
          var plural = word.noPlural || (0, _utils.isBlank)(word.pluralNoun) ? '-' : (_word$pluralNoun = word.pluralNoun) === null || _word$pluralNoun === void 0 ? void 0 : _word$pluralNoun.targetTextWithDefiniteArticle;
          return "".concat(singular, " \xB7 ").concat(plural);
        }
        return (_this$props$word3 = this.props.word) === null || _this$props$word3 === void 0 ? void 0 : _this$props$word3.formattedTargetText;
      }
    }, {
      key: "showReviewToggle",
      get: function get() {
        return !this.props.backend && this.hasVideoClipWithRoot && !this.props.word.targetTextContainsNumber && this.wordIsCorrectWordType && (!this.props.word.rootWord || !this.props.word.rootWord.excludeFromPublicLists);
      }
    }, {
      key: "wordIsCorrectWordType",
      get: function get() {
        var wordTypeId = this.props.word.rootWordTypeId || this.props.word.wordTypeId;
        return _constants.Constants.VOCAB_WORD_TYPES.map(function (item) {
          return item.id;
        }).includes(wordTypeId);
      }
    }, {
      key: "reasonToBlockReviewToggle",
      get: function get() {
        if (!this.hasVideoClipWithRoot) {
          return 'no-video-clip';
        } else if (this.props.word.targetTextContainsNumber) {
          return 'contains-number';
        } else if (!this.wordIsCorrectWordType) {
          return 'wrong-word-type';
        } else if (this.props.word.rootWord && this.props.word.rootWord.excludeFromPublicLists) {
          return 'excluded';
        }
      }
    }, {
      key: "hasVideoClipWithRoot",
      get: function get() {
        return this.props.word.hasVideoClip || (0, _utils.isPresent)(this.rootWordVideoClip);
      }
    }, {
      key: "rootWordVideoClip",
      get: function get() {
        var _this$props$word$root2;
        return (_this$props$word$root2 = this.props.word.rootWord) === null || _this$props$word$root2 === void 0 || (_this$props$word$root2 = _this$props$word$root2.target) === null || _this$props$word$root2 === void 0 ? void 0 : _this$props$word$root2.videoClip;
      }
    }, {
      key: "autoPlay",
      get: function get() {
        return !_state.DeckUI.vocabWordComprehendCard && (0, _utils.isBlank)(this.props.sentence) || (0, _utils.isPresent)(this.selectedVideoClip);
      }
    }, {
      key: "videoClip",
      get: function get() {
        return this.selectedVideoClip || this.props.word && this.props.word.videoClip || this.rootWordVideoClip || this.firstSentenceVideoClip;
      }
    }, {
      key: "wordSentences",
      get: function get() {
        return this.props.sentence ? null : _state.DeckUI.wordSentences;
      }
    }, {
      key: "hasVideoClip",
      get: function get() {
        return (0, _utils.isPresent)(this.videoClip);
      }
    }, {
      key: "height",
      get: function get() {
        if (this.props.height) {
          return this.props.height;
        } else {
          return _state.DeckUI.layout.deckHeight;
        }
      }
    }, {
      key: "infinitiveVerbTargetText",
      get: function get() {
        if (this.props.word && this.props.word.hasInfinitiveVerb && this.props.word.infinitiveVerb.targetText) {
          return this.props.word.infinitiveVerb.targetText;
        }
      }
    }, {
      key: "showWordType",
      get: function get() {
        return this.props.word && this.props.word.wordType && this.props.word.wordType.showInCard && this.props.sentence;
      }
    }, {
      key: "showWordTypeConcept",
      get: function get() {
        return this.props.word && this.props.word.hasWordTypeConcept && this.props.sentence;
      }
    }, {
      key: "showConjugationTable",
      get: function get() {
        return this.props.word && (this.props.word.hasInfinitiveVerb || this.props.word.isInfinitive);
      }
    }, {
      key: "blankSource",
      get: function get() {
        var _this$props$wordAssoc, _this$props$wordAssoc2, _this$props$wordAssoc3;
        return this.props.wordAssociation && (((_this$props$wordAssoc = this.props.wordAssociation) === null || _this$props$wordAssoc === void 0 ? void 0 : _this$props$wordAssoc.blankSource) || (0, _utils.isBlank)((_this$props$wordAssoc2 = this.props.wordAssociation) === null || _this$props$wordAssoc2 === void 0 ? void 0 : _this$props$wordAssoc2.source) || (0, _utils.isBlank)((_this$props$wordAssoc3 = this.props.wordAssociation) === null || _this$props$wordAssoc3 === void 0 || (_this$props$wordAssoc3 = _this$props$wordAssoc3.source) === null || _this$props$wordAssoc3 === void 0 ? void 0 : _this$props$wordAssoc3.text));
      }
    }, {
      key: "wordTypeText",
      get: function get() {
        if (_state.DeckUI.deck.languageId === 'DE') {
          return this.props.word && this.props.word.isNoun && this.props.word.caseAbbreviation ? "".concat(this.props.word.plural ? 'Plural' : 'Singular', " Noun, ").concat(_constants.Constants.CASE_NAMES[this.props.word.caseAbbreviation.toLowerCase()], " Case") : null;
        }
        return this.props.word && this.props.word.isNoun && this.props.word.caseAbbreviation ? "".concat(this.props.word.plural ? 'Plural' : 'Singular', " Noun") : null;
      }
    }, {
      key: "wordTypeLongDescription",
      get: function get() {
        var _this$props$word$word;
        return (_this$props$word$word = this.props.word.wordTypeConcept) === null || _this$props$word$word === void 0 ? void 0 : _this$props$word$word.longDescription;
      }
    }, {
      key: "wordTypeShortDescriptionMd",
      get: function get() {
        var _this$props$word$word2;
        return (_this$props$word$word2 = this.props.word.wordTypeConcept) === null || _this$props$word$word2 === void 0 || (_this$props$word$word2 = _this$props$word$word2.conceptCategory) === null || _this$props$word$word2 === void 0 ? void 0 : _this$props$word$word2.descriptionMd;
      }
    }, {
      key: "clearVideoClips",
      value: function clearVideoClips() {
        this.selectedVideoClip = null;
        this.supplementVideoClip = null;
      }
    }, {
      key: "onClickPlayVideo",
      value: function onClickPlayVideo(sentence) {
        if (!_state.DeckUI.layout.isNative) {
          document.getElementById('word-card').scrollIntoView();
        }
        var videoClip = sentence.target && sentence.target.videoClip;
        if (!videoClip) {
          return;
        }
        if (this.selectedVideoClip !== videoClip) {
          this.selectedVideoClip = videoClip;
          this.supplementVideoClip = sentence.videoClip;
        }
      }
    }, {
      key: "onClickRow",
      value: function onClickRow(id) {
        this.expandedId = this.expandedId === id ? null : id;
      }
    }, {
      key: "onCloseCard",
      value: function onCloseCard() {
        if (this.props.onClose) {
          this.props.onClose();
        } else {
          this.props.sentence.state.set('selectedWordAssociationId', null);
        }
      }
    }, {
      key: "onEnableSourceInput",
      value: function onEnableSourceInput() {
        this.showSourceInput = true;
      }
    }, {
      key: "onEnableSentenceInput",
      value: function onEnableSentenceInput() {
        this.showSentenceInput = true;
      }
    }, {
      key: "onSubmitSourceInput",
      value: function onSubmitSourceInput(data) {
        this.showSourceInput = false;
        data['user_id'] = _state.DeckUI.user.id;
        data['translation_id'] = this.props.word.id;
        _state.DeckUI.translationSourceStore.create({
          data: data
        }, this.reloadWord);
      }
    }, {
      key: "onSubmitSentenceInput",
      value: function onSubmitSentenceInput() {
        this.showSentenceInput = false;
      }
    }, {
      key: "reloadWord",
      value: function reloadWord() {
        this.props.card.getWord();
      }
    }, {
      key: "onToggleShowNoReviewExplanation",
      value: function onToggleShowNoReviewExplanation() {
        this.showNoReviewExplanation = !this.showNoReviewExplanation;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          user: _state.DeckUI.user,
          height: this.height,
          width: this.props.width || _state.DeckUI.layout.deckWidth,
          sentence: this.props.sentence,
          word: this.props.word,
          wordAssociation: this.props.wordAssociation,
          onCloseCard: this.onCloseCard,
          hasVideoClip: this.hasVideoClip,
          autoPlay: this.autoPlay,
          videoClip: this.videoClip,
          supplementVideoClip: this.supplementVideoClip,
          selectedVideoClip: this.selectedVideoClip,
          clearVideoClips: this.clearVideoClips,
          expandedId: this.expandedId,
          onClickRow: this.onClickRow,
          onClickPlayVideo: this.onClickPlayVideo,
          infinitiveVerbTargetText: this.infinitiveVerbTargetText,
          showWordType: this.showWordType,
          showWordTypeConcept: this.showWordTypeConcept,
          showConjugationTable: this.showConjugationTable,
          wordSentences: this.wordSentences,
          showSourceInput: this.showSourceInput,
          showSentenceInput: this.showSentenceInput,
          onEnableSourceInput: this.onEnableSourceInput,
          onEnableSentenceInput: this.onEnableSentenceInput,
          onSubmitSourceInput: this.onSubmitSourceInput,
          onSubmitSentenceInput: this.onSubmitSentenceInput,
          blankSource: this.blankSource,
          isMobile: _state.DeckUI.layout.isMobile,
          primaryTranslationText: this.primaryTranslationText,
          wordTypeText: this.wordTypeText,
          wordTypeLongDescription: this.wordTypeLongDescription,
          wordTypeShortDescriptionMd: this.wordTypeShortDescriptionMd,
          showReviewToggle: this.showReviewToggle,
          reasonToBlockReviewToggle: this.reasonToBlockReviewToggle,
          onToggleShowNoReviewExplanation: this.onToggleShowNoReviewExplanation,
          showNoReviewExplanation: this.showNoReviewExplanation,
          onToggleLearned: _state.VocabUI.onToggleLearned
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "expandedId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "selectedVideoClip", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "supplementVideoClip", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showSourceInput", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "showSentenceInput", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showNoReviewExplanation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "primaryTranslationText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "primaryTranslationText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showReviewToggle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showReviewToggle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordIsCorrectWordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordIsCorrectWordType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reasonToBlockReviewToggle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reasonToBlockReviewToggle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasVideoClipWithRoot", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVideoClipWithRoot"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "rootWordVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "rootWordVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "autoPlay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "autoPlay"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordSentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordSentences"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "height", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "height"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "infinitiveVerbTargetText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "infinitiveVerbTargetText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordTypeConcept", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordTypeConcept"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showConjugationTable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showConjugationTable"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "blankSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "blankSource"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordTypeText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordTypeText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordTypeLongDescription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordTypeLongDescription"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordTypeShortDescriptionMd", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordTypeShortDescriptionMd"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearVideoClips", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearVideoClips"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickPlayVideo", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickPlayVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickRow", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickRow"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCloseCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCloseCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onEnableSourceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onEnableSourceInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onEnableSentenceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onEnableSentenceInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmitSourceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmitSourceInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmitSentenceInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmitSentenceInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reloadWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "reloadWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleShowNoReviewExplanation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleShowNoReviewExplanation"), _class2.prototype), _class2)) || _class;
};
WordCardWrapper.displayName = 'WordCardWrapper';
var _default = exports["default"] = WordCardWrapper;